import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userBoffinSlice from './userBoffinSlice'
import authReducer from './userAuthSlice'
import flexicoRerunReducer from './flexicoRerunSlice'
import pulseSurveyTriggerReducer from './pulseSurveyTriggerSlice'

import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'


const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['flexicoRerun', 'pulseSurveyTrigger'],
  }

  const rootReducer = combineReducers({ 
    auth: authReducer,
    boffin: userBoffinSlice,
    flexicoRerun: flexicoRerunReducer,
    pulseSurveyTrigger: pulseSurveyTriggerReducer,
  })

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const globalStore = configureStore({
    reducer: persistedReducer
})

export const persistor = persistStore(globalStore)


// export default globalStore